import { createFileRoute } from '@tanstack/react-router'
import SamsungSmartThingsOAuth2Redirected from '~containers/samsung.smart-things/oauth2-redirected'

interface SearchParams {
  code: string
  state: string
}

export const Route = createFileRoute('/samsung/smart-things/(temp)/login/oauth2')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    if (typeof search.code !== 'string' || typeof search.state !== 'string') {
      throw new Error('Invalid access')
    }

    return {
      code: search.code,
      state: search.state,
    }
  },
})

function RouteComponent() {
  const response = Route.useSearch()
  return <SamsungSmartThingsOAuth2Redirected response={response} />
}
